<template>
  <div class="liu">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="onGoBackClick">返回</mt-button>
      <mt-button v-if="false" slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <mt-loadmore :top-method="onLoadmoreTapLoad" ref="loadmore">
        <!-- 提示行 -->
        <!-- 如果有tips提示信息，此div样式要用class="tips-box" -->
        <div />
        <!-- 空页 -->
        <div v-if="isShowEmptyData"></div>
        <!-- 列表信息 -->
        <div class="pay-risk-management">
          <div v-if="isShowListData">
            <div class=" row" v-for="(item, index) in myData.list" :key="index" @click="onListItemClick(item)">
              <div class="left">
                <div class="img-div">
                  <img :src="require('@/assets/payment_record@3x.png')" alt="" />
                </div>
                <div class="content">
                  <div class="title">
                    <span>{{ item.dfAccountLogContent.split("-")[0] }}</span>
                  </div>
                  <div class="title bold">
                    <span class="bold">{{ item.dfAccountLogContent.split("-")[1] }}</span>
                  </div>
                  <div class="date">
                    <span>{{ item.insertDate }}</span>
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="money">
                  <span>-{{ item.money | money }}</span>
                </div>
                <div class="status">
                  <span>{{ item.status | chs }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 无数据占位图 -->
        <div v-if="isShowNoData">
          <div class="no-data">
            <img src="../assets/records-empty@3x.png" width="60%" />
            <div class="title-4">暂无记录</div>
          </div>
        </div>
      </mt-loadmore>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { Indicator } from 'mint-ui';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import { GetPayTagRiskList } from '@/api/user';
import { CusToast } from '@/utils/CustomToast';

export default {
  name: 'RiskManagementList',
  data() {
    return {
      title: '结算风控',
      product: PUBLIC_PRODUCT,
      // 商户
      myData: {
        list: [],
        total: -1,
        inviteUser: false,
        scrollDisabled: true,
        selectedItem: null,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 8,
      },
      // 查询数据
      search: {
        // 状态
        type: {
          list: [
            { name: '全部', value: 0 },
            { name: '未认证', value: 1 },
            { name: '已认证', value: 2 },
            { name: '已实名', value: 3 },
          ],
        },
        // 达标状态
        reachType: {
          list: [
            { name: '全部', value: -1 },
            { name: '未达标', value: 0 },
            { name: '已达标', value: 1 },
          ],
        },
        // 销售政策阶段
        agentSaleTask: {
          list: [],
        },
        // 商户名
        user: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 代理商名
        agent: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        // 金额
        money: {
          min: null,
          max: null,
        },
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关
      visible: {
        search: false,
        user: false,
        agent: false,
      },
      // 禁用开关
      disabled: {
        hasSelectedCustomer: false,
      },
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 页数重置为1
      this.myParam.pageNum = 1;
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      GetPayTagRiskList(this.myParam)
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.total = res.total;
            this.myData.list.push(...res.rows);
            // 通过记录条数list.length和数据总数total判断是否查询出所有数据
            // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
            if (this.myData.list.length < this.myData.total) {
              this.myData.scrollDisabled = false;
            }
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          this.myData.total = -1;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 跳页
    onListItemClick(item) {
      this.$router.push({ path: '/payriskmanagementdetail', query: { id: item.id, status: item.status } });
    },
    // 返回事件
    onGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 下拉刷新页面
    onLoadmoreTapLoad() {
      this.initData();
      this.$refs.loadmore.onTopLoaded();
    },
  },
  filters: {
    money(val) {
      let m = '';
      if (val.toString().length === 1) {
        m = `000${val.toString()}`;
      } else if (val.toString().length === 2) {
        m = `00${val.toString()}`;
      } else if (m.length === 3) {
        m = `0${val.toString()}`;
      } else {
        m = val.toString();
      }
      const nm = `${m.substring(0, m.length - 2)}.${m.substr(-2)}`;
      return nm.indexOf('0') === 0 ? nm.substring(1) : nm;
    },
    chs(val) {
      if (val === 0) return '未提交';
      if (val === 1) return '待审核';
      if (val === 2) return '审核成功';
      if (val === 3) return '审核失败';
    },
  },
};
</script>
